import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { getAppPermissions } from '../../services/appService';
import { isLoggedInState } from '../../storage/app';
import { appPermissionState } from '../../storage/permissions';

export function PermissionsProvider() {
  const isLoggedIn = useRecoilValue(isLoggedInState);
  const setAppPermission = useSetRecoilState(appPermissionState);

  useEffect(() => {
    if (!isLoggedIn) return;
    const loadAppPermissions = async () => {
      const { appPermissions, error } = await getAppPermissions();
      if (!error && appPermissions) {
        setAppPermission(appPermissions);
      }
    };

    loadAppPermissions();
  }, [isLoggedIn]);

  return null;
}
